import { render, staticRenderFns } from "./task-batch-management.vue?vue&type=template&id=5dde43cd&scoped=true&"
import script from "./task-batch-management.vue?vue&type=script&lang=js&"
export * from "./task-batch-management.vue?vue&type=script&lang=js&"
import style0 from "./task-batch-management.vue?vue&type=style&index=0&id=5dde43cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dde43cd",
  null
  
)

export default component.exports